import text from './text.json'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {deleteAccountPermanently} from '../../stores/customer-settings'
import {PageSubTitle, PageTitle, ResponsivePageTitle} from '../../components/core/title'
import {SimpleBlueButton} from '../../components/core/button'
import ContentLoader from '../../components/core/loader'
import Footer from '../../components/layouts/footer'
import {routes} from '../../routes'
import {useEffect, useState} from 'react'
import CustomerService from './../../api/customer'
import CustomSelect from '../../components/core/customSelect'
import {Formik} from 'formik'
import {deletionReasonSchema} from '../../utils/validation'
import Customer from '../../utils/customer'
import classNames from 'classnames'
import {NothinghereIcon} from '../../icons'

const DeleteAccount = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const logoutIsProcessing = useSelector(state => state.auth.logoutIsProcessing)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const [deletionReasons, setDeletionReasons] = useState([])
    const isRootMember = Customer.isRoot()

    const initialFormValues = {
        reason: ''
    }

    const deleteAccount = async(values) => {
        await dispatch(deleteAccountPermanently({reason: values?.reason.value}))
    }

    const redirectToHome = () => navigate(routes.resources.path)

    const getDeletionReasonsData = async() => {
        if (isRootMember) {
            try {
                const {data} = await CustomerService.getDeletionReasons()
                setDeletionReasons(data?.data?.reasons.map(item => {
                    return {
                        value: item?.key,
                        label: item?.description
                    }
                }))
            } catch (e) {
                return false
            }
        }
    }

    useEffect(() => {
        getDeletionReasonsData()
    }, [])

    const styles = {
        fontWeight: 400,
        lineHeight: '40px'
    }

    return (
        <main className={classNames('main settings', {
            dark: isDarkMode
        })}>
            <div>
                <ResponsivePageTitle/>
                <div className="content-title">
                    <div className="left-side">
                        <div>
                            <PageSubTitle>
                                <p className={classNames('section', {
                                    dark: isDarkMode
                                })}>{text.section}</p>
                            </PageSubTitle>
                            <PageTitle>
                                <h1  className={classNames('page-title', {
                                    dark: isDarkMode
                                })}>{text.title}</h1>
                            </PageTitle>
                        </div>
                    </div>
                </div>
                {logoutIsProcessing ? (<ContentLoader/>) : (
                    isRootMember ? (
                        <div className={classNames('content-body', {
                            dark: isDarkMode
                        })}>
                            <div className="delete-info" dangerouslySetInnerHTML={{__html: text.delete_account_info}}/>
                            {isRootMember && (
                                <div className="deletion-reason">
                                    <Formik
                                        onSubmit={deleteAccount}
                                        initialValues={initialFormValues}
                                        validationSchema={deletionReasonSchema}
                                        validateOnBlur={false}
                                        validateOnChange={false}>
                                        {({values, errors, setFieldValue, handleSubmit}) => (
                                            <form onSubmit={handleSubmit} className="form-elements">
                                                <CustomSelect
                                                    options={deletionReasons}
                                                    name='reason'
                                                    placeholder={text.deletion_reason}
                                                    onChange={setFieldValue}
                                                    infoText={text.deletion_reason_info}
                                                    error={errors.reason}
                                                    value={values.reason}
                                                    isClearable
                                                />
                                                <div className="buttons">
                                                    <SimpleBlueButton
                                                        type="button"
                                                        onClick={redirectToHome}
                                                        children={text.cancel}/>
                                                    <SimpleBlueButton
                                                        type="submit"
                                                        children={text.delete}/>
                                                </div>
                                            </form>
                                        )}
                                    </Formik>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={classNames('empty-content-body', {
                            dark: isDarkMode
                        })}>
                            <NothinghereIcon/>
                            <p style={styles} dangerouslySetInnerHTML={{__html: text.permission_text}}/>
                        </div>
                    )
                )}
            </div>
            <Footer/>
        </main>
    )
}

export default DeleteAccount
